import Vue from 'vue';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}

import { initBiPoint } from '../../resource/plugins/biPoint/index';

import AnalyzePoint, {
  routerEnter
} from '../../resource/plugins/AnalyzePoint/index';
Vue.use(AnalyzePoint('global-pay', 'officialStore', true));

import App from '../../officialStoreApp.vue';
import router from '../rooters/officialStore';
import store from '../stores/officialStore';
import commonComponents from '@components/officialStore/common/commonComponents';
import clickThrottling from '../../resource/plugins/clickThrottling';
import GlobalTip from '../../resource/plugins/officialGlobalTip';
import 'swiper/css/swiper.css';
import { handleStoreDefaultCid } from '@utiles/storeHandleCid';
import '@plugins/replaceAllPolyfills';
handleStoreDefaultCid();

initBiPoint({ dataLayerName: 'webstorev1DataLayer' });

// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(800);

// globalConfig.setVuePrototypePlatformConfig(Vue)

Vue.config.productionTip = true;
Vue.use(commonComponents);

Vue.prototype.$globalTip = GlobalTip;

router.beforeEach((to, _from, next) => {
  routerEnter(to.name);
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#officialStore');
